export default __webpack_public_path__ + "static/media/blackPeople19.6770c240.svg";